export class EntidadeEntidade {
	public COD_ENTID: number;
	public SIGLA_ENTID: string;
	public NOME_ENTID: string;
	public GRP_INVEST: string;
	public GRP_ADMINIST: string;
	public GRP_PREVI: string;
	public GRP_ASSIST: string;
	public BANCO: string;
	public FUNDACAO: string;
	public EMPRESA_SA: string;
	public CUSTODIANTE: string;
	public CORRETORA: string;
	public FORNECEDOR: string;
	public PREST_SERV: string;
	public PARTICIPANTE: string;
	public RECEB_BENEF: string;
	public CD_TIPO_CORRESP: string;
	public PATROCINADORA: string;
	public LOCATARIO: string;
	public COD_CUSTOD: string;
	public SEGURADORA: string;
	public COD_CETIP: string;
	public FISIC_JURID: string;
	public CPF_CGC: string;
	public ISS: string;
	public NUM_BANCO: string;
	public NUM_AGENCIA: string;
	public NUM_CONTA: string;
	public END_ENTID: string;
	public BAIRRO_ENTID: string;
	public CID_ENTID: string;
	public UF_ENTID: string;
	public CEP_ENTID: string;
	public FONE_ENTID: string;
	public FAX_ENTID: string;
	public CONTA_AUX: string;
	public OBS_ENTID: string;
	public E_MAIL: string;
	public CX_POSTAL: string;
	public NR_END_ENTID: string;
	public COMP_END_ENTID: string;
	public COD_ISIN: string;
	public TP_CONTA: string;
	public AUTONOMO: string;
	public DEPENDENTE?: number;
	public ISENTO_RETENCAO: string;
	public INSCRICAO_INSS: string;
	public CBO: string;
	public INSCRICAO_ISS: string;
	public OBRIG_CONTR: string;
	public EMIT_RESP: string;
	public SEXO: string;
	public DT_NASCIMENTO?: Date;
	public NATURALIDADE: string;
	public NACIONALIDADE: string;
	public ESTADO_CIVIL: string;
	public NOME_PAI: string;
	public NOME_MAE: string;
	public CONJUGE: string;
	public IDENTIDADE: string;
	public ORGAO_EXP: string;
	public DT_EXPEDICAO?: Date;
	public NATUREZA_DOC: string;
	public OCUPACAO_PROF: string;
	public NIRE: string;
	public ATIVIDADE_PRINC: string;
	public REPRES_BENEF: string;
	public GERA_DES: string;
	public CD_EXTERNO: string;
	public SIT_PAT_FINANCEIRA: string;
	public SIT_PAT_RENDIMENTOS: string;
	public PF_ENQUADRAMENTO: string;
	public RECEBE_EMAIL: string;
	public SENHA: string;
	public SENHA_ANT1: string;
	public SENHA_ANT2: string;
	public SENHA_ANT3: string;
	public SENHA_ANT4: string;
	public SENHA_ANT5: string;
	public POLIT_EXP: string;
	public TIPO_PPE: string;
	public COD_OCORRENCIA: string;
	public COD_CATEGORIA: string;
	public NUM_CONTA_SAL: string;
	public NUM_BANCO_SAL: string;
	public NUM_AGENCIA_SAL: string;
	public AG_RISCO: string;
	public COD_IMP_PATRIM: string;
	public ATIVO: string;
	public TP_REGIME_TRIBUTACAO?: number;
	public IND_TIPO_CONTA: string;
	public E_MAIL_CONTATO: string;
	public BLOQUEADA: string;
	public NUM_TENTATIVAS?: number;
	public DT_EXPIRA?: Date;
	public NUM_PROX_SENHA_ALT?: number;
	public PLANO: string;
	public CONSOLIDADO: string;
	public RECEB_RESGATE: string;
	public DEBITO_AUTO: string;
	public AUTORIZA_DEB: string;
	public NUM_NIF_EFINANCEIRA: string;
	public IND_FATCA: string;
	public CD_PAIS_EFINANCEIRA: string;
	public IND_DESONERA_CPRB: string;
}
